var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { IntroTitle, IntroForm } from './index';
/**
 * You can write the short and impactful content by using an Intro component.
 * TIP: Create short and impactful content so that anyone who sees your introductory content can immediately make a strong impression.
 *
 * @props id:	Name to be added to Sidebar.
 * @props title: Title of Intro section. (default: 'Intro')
 * @props titleColor: title text color style. (default: 'black')
 * @props shortIntro: Main text that can express you the best.(default: 'shortIntro that will captivate people')
 * @props shortIntroColor: shortIntro text color style. (default: 'black')
 * @props description: Introduce yourself. (default: `This props name is description.\nPlease write down your brief introduction here. If you want to change the line, type backslash-n between the letters. Also you want to move the letters to the center, change textAlign to center. code your dreams!`)
 * @props descriptionColor: description text color style. (default: 'black')
 * @props descriptionBackgroundColor: description background color style. (default: 'white')
 * @props textAlign: Intro text align	style. You can choose one of the themes such as 'left' and 'center'. (default: 'left')
 * @props backgroundColor: Intro background color style. (default: 'whitesmoke')
 */
var Intro = function (_a) {
    var id = _a.id, title = _a.title, titleColor = _a.titleColor, shortIntro = _a.shortIntro, shortIntroColor = _a.shortIntroColor, description = _a.description, descriptionColor = _a.descriptionColor, descriptionBackgroundColor = _a.descriptionBackgroundColor, textAlign = _a.textAlign, backgroundColor = _a.backgroundColor;
    return (_jsxs(Wrap, __assign({ id: id, textAlign: textAlign, backgroundColor: backgroundColor }, { children: [_jsx(IntroTitle, { title: title, titleColor: titleColor, shortIntro: shortIntro, shortIntroColor: shortIntroColor }), _jsx(IntroForm, { description: description, descriptionColor: descriptionColor, descriptionBackgroundColor: descriptionBackgroundColor })] })));
};
export default Intro;
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 30px;\n  padding-top: 20px;\n  white-space: pre-wrap;\n  text-align: ", ";\n  background-color: ", ";\n  @media screen and (max-width: 480px) {\n    padding: 0px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 30px;\n  padding-top: 20px;\n  white-space: pre-wrap;\n  text-align: ", ";\n  background-color: ", ";\n  @media screen and (max-width: 480px) {\n    padding: 0px;\n  }\n"])), function (_a) {
    var textAlign = _a.textAlign;
    return textAlign;
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
});
Intro.defaultProps = {
    title: 'Intro',
    titleColor: 'black',
    shortIntro: 'shortIntro that will captivate people',
    shortIntroColor: 'black',
    description: 'This props name is description.\nPlease write down your brief introduction here.\nIf you want to change the line, type backslash-n between the letters.\nAlso you want to move the letters to the center, change textAlign to center.\n\ncode your dreams!',
    descriptionColor: 'black',
    descriptionBackgroundColor: 'white',
    textAlign: 'left',
    backgroundColor: 'whitesmoke',
};
var templateObject_1;
